module.exports = __webpack_public_path__ + "static/media/404-page-background.1158f2e8.svg";